import type { FC } from "react";

import { useJiraSetupView } from "../../hooks/useJiraSetupView";
import { Alert } from "../common/Alert";
import {
  ConnectUrlBlock,
  ForgeInstallCommandBlock,
  InstalledView,
  SetupSteps,
} from "../common/JiraSetupView";
import { LoadingState } from "../common/LoadingState";
import { PanelSection } from "../common/PanelSection";

export const JiraSetupPanel: FC = () => {
  const { view, retry } = useJiraSetupView();

  if (view.status === "loading") {
    return (
      <PanelSection title="Jira">
        <LoadingState variant="skeleton" rows={3} />
      </PanelSection>
    );
  }

  if (view.status === "error") {
    return (
      <PanelSection title="Jira">
        <Alert variant="error">{view.message}</Alert>
      </PanelSection>
    );
  }

  if (view.status === "installed") {
    return (
      <PanelSection title="Jira">
        <InstalledView
          detail={view.detail}
          onRefresh={retry}
          footer={
            <a
              href={`/integrations?tab=issues&provider=${encodeURIComponent(view.detail.provider.provider_id)}`}
              className="inline-flex items-center gap-1.5 font-mono text-[10px] font-bold uppercase tracking-widest text-emerald-600 transition-colors hover:text-emerald-700 dark:text-emerald-300 dark:hover:text-emerald-200"
            >
              <svg
                className="h-3.5 w-3.5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                />
              </svg>
              Manage in Integrations
            </a>
          }
        />
      </PanelSection>
    );
  }

  return (
    <PanelSection title="Jira">
      <div className="space-y-4">
        <Alert variant="info">
          <p className="text-xs">
            Connect Jira to let Arti receive and work on issues. Install the
            Arti app in your Jira instance to get started.
          </p>
        </Alert>

        <SetupSteps currentStep={0} />

        {view.connectUrl ? (
          <ConnectUrlBlock connectUrl={view.connectUrl} />
        ) : (
          <ForgeInstallCommandBlock />
        )}
      </div>
    </PanelSection>
  );
};
